(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sj-card-product"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__sjWishlistInit) return;
  window.__sjWishlistInit = true;

  function getIds() {
    try { return JSON.parse(localStorage.getItem('sj_wishlist') || '[]'); } catch (e) { return []; }
  }
  function getData() {
    try { return JSON.parse(localStorage.getItem('sj_wishlist_data') || '[]'); } catch (e) { return []; }
  }
  function saveIds(ids) {
    try { localStorage.setItem('sj_wishlist', JSON.stringify(ids)); } catch (e) {}
  }
  function saveData(data) {
    try { localStorage.setItem('sj_wishlist_data', JSON.stringify(data)); } catch (e) {}
  }

  function updateHeaderBadge() {
    var count = getData().length;
    var badge = document.getElementById('sj-wl-badge');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
    window.dispatchEvent(new Event('sj:wishlist:updated'));
  }

  window.sjUpdateWishlistCount = updateHeaderBadge;

  function syncBtn(btn) {
    btn.classList.toggle('sj-prodcard__wish--on', getIds().indexOf(String(btn.dataset.pid)) > -1);
  }

  document.querySelectorAll('.sj-prodcard__wish').forEach(syncBtn);
  updateHeaderBadge();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sj-prodcard__wish');
    if (!btn) return;
    e.preventDefault();
    var pid = String(btn.dataset.pid);
    var ids = getIds();
    var data = getData();
    var idx = ids.indexOf(pid);
    if (idx > -1) {
      ids.splice(idx, 1);
      data = data.filter(function (d) { return String(d.id) !== pid; });
    } else {
      ids.push(pid);
      data.push({
        id: pid,
        url: btn.dataset.url || '',
        title: btn.dataset.title || '',
        price: btn.dataset.price || '',
        compare: btn.dataset.compare || '',
        discount: btn.dataset.discount || '',
        image: btn.dataset.image || ''
      });
    }
    saveIds(ids);
    saveData(data);
    syncBtn(btn);
    updateHeaderBadge();
  });

  /* Finish swatch hover — swap the card's main image (opt-in feature) */
  document.addEventListener('mouseenter', function (e) {
    var sw = e.target.closest && e.target.closest('.sj-prodcard__swatch');
    if (!sw || !sw.dataset.img) return;
    var img = document.getElementById('sj-prodcard-img-' + sw.dataset.card);
    if (img) img.src = sw.dataset.img;
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sj-promo-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  function initPromoPopups() {
    document.querySelectorAll('.sj-promo-popup').forEach(function (popup) {
      if (popup.dataset.bound) return;
      popup.dataset.bound = '1';

      var key = popup.dataset.promoKey;
      if (!key || sessionStorage.getItem(key)) return;

      var delaySeconds = parseFloat(popup.dataset.delay) || 3;

      function close() {
        popup.hidden = true;
        sessionStorage.setItem(key, '1');
      }

      setTimeout(function () { popup.hidden = false; }, delaySeconds * 1000);

      popup.querySelector('.sj-promo-popup__overlay').addEventListener('click', close);
      popup.querySelector('.sj-promo-popup__close').addEventListener('click', close);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromoPopups);
  } else {
    initPromoPopups();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
